import { render, staticRenderFns } from "./social-media-bar.vue?vue&type=template&id=590ccbdb&scoped=true&"
import script from "./social-media-bar.vue?vue&type=script&lang=js&"
export * from "./social-media-bar.vue?vue&type=script&lang=js&"
import style0 from "./social-media-bar.vue?vue&type=style&index=0&id=590ccbdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ccbdb",
  null
  
)

export default component.exports